import * as React from "react";
import classnames from "classnames";
/* empty css               */
const Accordion = ({ children, className, ...rest }) => /* @__PURE__ */ React.createElement("article", { className: classnames("accordion", className), "data-t": rest["data-t"] || "accordion" }, children);
export {
  Accordion,
  Accordion as default
};
//# sourceMappingURL=Accordion.js.map
